<template>
  <div>
    <v-card class="pa-3">
      <v-card-title class="headline pl-2 pt-2">Update Route</v-card-title>

      <v-layout row>
        <v-layout column xs6 class="pr-2" style="min-width: 50%">
          <v-text-field
            class="mx-2 mb-2"
            v-model="rowClicked.description"
            label="Description"
            ref="description"
            :rules="[rules.required]"
          ></v-text-field>
          <v-select
            class="mx-2 mb-2"
            v-model="rowClicked.direction"
            label="Direction"
            ref="direction"
            :rules="[rules.required]"
            :items="['Pickup', 'Dropoff']"
          ></v-select>
          <v-select
            class="mx-2 mb-2"
            v-model="rowClicked.buildings"
            label="Buildings"
            :items="buildingList"
            multiple
            :rules="[rules.required]"
          ></v-select>
          <v-select
            class="mx-2 mb-2"
            v-model="rowClicked.grades"
            label="Grades"
            :items="gradeList"
            multiple
            :rules="[rules.required]"
          ></v-select>
          <v-select
            class="mx-2 mb-2"
            v-model="rowClicked.weekDays"
            label="Weekdays"
            :items="weekDayList"
            multiple
          ></v-select>

          <!-- <v-select
                            class="mx-2 mb-2"
                            v-model="rowClicked.term"
                            label="Term"
                            ref="term"
                            :items="terms"
                            :rules="[rules.required]"
                            disabled
                        ></v-select> -->

          <v-layout row class="mb-0">
            <div class="font-weight-regular ml-2 pt-2 pb-1">
              Time Start:
            </div>
            <DxDateBox
              type="time"
              picker-type="list"
              :interval="12"
              class="mx-2 mb-2"
              v-model="rowClicked.timeStart"
              :rules="[rules.required]"
            />
          </v-layout>
          <v-text-field
            class="mx-2 mb-0"
            v-model="rowClicked.notes"
            label="Notes"
            ref="notes"
          ></v-text-field>
          <v-text-field
            class="mx-2 mb-0"
            v-model="rowClicked.color"
            label="Color"
            ref="color"
          ></v-text-field>

          <v-layout row>
            <v-text-field
              class="mx-2 mb-0"
              v-model="rowClicked.routeIdentifier"
              label="Route Identifier"
              ref="routeIdentifier"
              :rules="[rules.required]"
            ></v-text-field>
            <v-select
              class="mx-2 mb-0"
              v-model="rowClicked.groupBy"
              label="Group"
              ref="groupBy"
              :rules="[rules.required]"
              :items="['AM', 'PM', 'CUSTOM', 'FAM', 'PPM']"
            ></v-select>
          </v-layout>

          <v-checkbox
            v-model="rowClicked.goeNotRequired"
            class="mx-2 mt-0"
            label="GOE Not Required"
            color="success"
            hide-details
          ></v-checkbox>
        </v-layout>
        <v-layout column xs6 class="pl-2" style="min-width: 50%">
          <v-layout row style="max-height: 41px;">
            <div class="mb-2 headline">
              Route Schedules
            </div>
            <v-btn
              color="success"
              small
              class="ml-3 my-0"
              style="max-height: 28px;"
              @click="openAddRouteSchedule"
              >Add</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
          <div style="overflow-y: auto; height: 473px">
            <div v-for="(routeSchedule, index) in rowClicked.routeSchedules">
              <div
                class="pa-2 mb-2 mr-3"
                style="border: #5cb860 1px solid; border-radius: 5px;"
              >
                <v-layout row class="mb-0">
                  <div class="font-weight-medium mr-2 pt-2">
                    Driver Bus:
                  </div>
                  <div class="pt-2">
                    {{ routeSchedule.driver_bus }}
                  </div>
                  <v-spacer></v-spacer
                  ><v-btn
                    class="pt-0 my-0"
                    flat
                    icon
                    color="success"
                    @click.stop="editRouteSchedule(routeSchedule)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    class="pt-0 my-0"
                    flat
                    icon
                    color="success"
                    @click.stop="openDeleteRouteSchedule(routeSchedule)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row class="mb-2">
                  <div class="font-weight-medium mr-2">
                    Start Date:
                  </div>
                  <div>
                    {{ routeSchedule.dateFrom }}
                  </div> </v-layout
                ><v-layout row class="mb-2">
                  <div class="font-weight-medium mr-2">
                    End Date:
                  </div>
                  <div>
                    {{ routeSchedule.dateTo }}
                  </div> </v-layout
                ><v-layout row class="mb-2">
                  <div class="font-weight-medium mr-2">
                    Term:
                  </div>
                  <div>{{ routeSchedule.term }}</div>
                </v-layout>
              </div>
            </div>
          </div>
        </v-layout>
      </v-layout>

      <v-card-actions class="mx-0 px-2 pb-2 mt-2">
        <v-spacer></v-spacer>
        <v-btn color="default" dark @click="closeUpdateRouteDialog()"
          >Close</v-btn
        >
        <v-btn :loading="processing" color="success" @click="saveRoute()">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog persistent v-model="routeScheduleEditDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Update Route Schedule</v-card-title
        >
        <v-autocomplete
          class="mx-1"
          label="Driver / Bus"
          v-model="routeScheduleToEdit.driver_bus"
          :items="driver_busList.map((b) => b.displayName)"
          ref="driver_bus"
          :rules="[
            (value) => rules.busDriverRequired(value, routeScheduleToEdit),
          ]"
        ></v-autocomplete>
        <v-menu
          v-model="routeScheduleToEdit.dateFromPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToEdit.dateFrom"
              :value="formatedDate(routeScheduleToEdit.dateFrom)"
              label="Start Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToEdit.dateFrom"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="routeScheduleToEdit.dateToPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToEdit.dateTo"
              :value="formatedDate(routeScheduleToEdit.dateTo)"
              label="End Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToEdit.dateTo"></v-date-picker>
        </v-menu>
        <v-select
          class="mb-2"
          v-model="routeScheduleToEdit.term"
          label="Term"
          ref="routeScheduleTerm"
          :items="terms"
          :rules="[rules.required]"
        ></v-select>
        <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="routeScheduleEditDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="
              saveRouteSchedule({
                routeSchedule: routeScheduleToEdit,
              })
            "
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >

    <v-dialog persistent v-model="addRouteScheduleDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Add Route Schedule</v-card-title
        >
        <v-autocomplete
          class="mx-1"
          label="Driver / Bus"
          v-model="routeScheduleToAdd.driver_bus"
          :items="driver_busList.map((b) => b.displayName)"
          ref="driver_bus"
          :rules="[
            (value) => rules.busDriverRequired(value, routeScheduleToAdd),
          ]"
        ></v-autocomplete>
        <v-menu
          v-model="routeScheduleToAdd.dateFromPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToAdd.dateFrom"
              :value="formatedDate(routeScheduleToAdd.dateFrom)"
              label="Start Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToAdd.dateFrom"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="routeScheduleToAdd.dateToPickerMenu"
          :close-on-content-click="true"
          offset-y
          full-width
          prepend-icon="mdi-currency-usd"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="routeScheduleToAdd.dateTo"
              :value="formatedDate(routeScheduleToAdd.dateTo)"
              label="End Date"
              prepend-icon="mdi-calendar"
              clearable
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="routeScheduleToAdd.dateTo"></v-date-picker>
        </v-menu>
        <v-select
          class="mb-2"
          v-model="routeScheduleToAdd.term"
          label="Term"
          ref="routeScheduleTerm"
          :items="terms"
          :rules="[rules.required]"
        ></v-select>
        <v-card-actions class="mx-0 pr-0 pb-2 mt-2">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="addRouteScheduleDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="
              saveRouteSchedule({
                routeSchedule: routeScheduleToAdd,
              })
            "
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >

    <v-dialog persistent v-model="routeScheduleDeleteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Delete Route Schedule</v-card-title
        >

        <div
          class="pa-2 mb-2"
          style="border: #5cb860 1px solid; border-radius: 5px;"
        >
          <v-layout row class="mb-2">
            <div class="font-weight-medium mr-2 pt-2">
              Driver Bus:
            </div>
            <div class="pt-2">
              {{ routeScheduleToDelete.driver_bus }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              Start Date:
            </div>
            <div>
              {{ routeScheduleToDelete.dateFrom }}
            </div> </v-layout
          ><v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              End Date:
            </div>
            <div>
              {{ routeScheduleToDelete.dateTo }}
            </div> </v-layout
          ><v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              Term:
            </div>
            <div>{{ routeScheduleToDelete.term }}</div>
          </v-layout>
        </div>

        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="routeScheduleDeleteDialog = false"
            >Close</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="deleteRouteSchedule"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="routeScheduleAbsentsDialog" max-width="400">
      <v-card class="pa-3">
        <div class="text-danger font-weight-medium">
          We found absent reports for the below drivers, please delete them
          first.
        </div>

        <div
          class="font-weight-medium title mt-3"
          v-if="
            routeScheduleAbsents.existingDriverAbsents &&
              routeScheduleAbsents.existingDriverAbsents.length
          "
        >
          {{
            "Current Driver: " +
              getDriverByDriverBusID(
                routeScheduleAbsents.existingDriverAbsents[0].driver_Bus_ID
              ) +
              " Absents"
          }}
        </div>
        <div
          style="overflow-y: auto; height: 150px; border: 1px solid #4caf50; padding: 8px;"
          v-if="
            routeScheduleAbsents.existingDriverAbsents &&
              routeScheduleAbsents.existingDriverAbsents.length
          "
        >
          <div
            v-for="(absent,
            index) in routeScheduleAbsents.existingDriverAbsents"
          >
            <div class="font-weight-regular" v-if="absent.id">
              {{ absent.date | date }}
            </div>
            <div class="caption" v-if="absent.id">
              {{
                absent.timeStart +
                  " - " +
                  absent.buildings +
                  " - " +
                  (absent.grades ? absent.grades : "")
              }}
            </div>
            <v-divider
              class="my-2"
              v-if="
                index + 1 < routeScheduleAbsents.existingDriverAbsents.length
              "
            ></v-divider>
          </div>
        </div>

        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            dark
            @click="routeScheduleAbsentsDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DxDateBox from "devextreme-vue/date-box";
import moment from "moment";

export default {
  components: {
    DxDateBox,
  },
  props: {
    rowClicked: Object,
    driver_busList: Array,
    buildingList: Array,
    gradeList: Array,
    terms: Array,
    loadRouteSchedules: Function,
    reloadGrid: Function,
    closeUpdateRouteDialog: Function,
  },
  components: {
    DxDateBox,
  },
  data: () => ({
    title: "Routes",

    actions: [],

    updateRouteDialog: false,
    addNewRouteDialog: false,

    routeScheduleToAdd: {
      driver_bus: "",
      type: "Default",
      dateFromPickerMenu: false,
      dateFrom: "",
      dateToPickerMenu: false,
      dateTo: "",
      term: "",
      id: 0,
    },

    routeScheduleToEdit: {},
    routeScheduleToDelete: {},
    routeScheduleEditDialog: false,
    routeScheduleDeleteDialog: false,
    addRouteScheduleDialog: false,
    addRouteSchedulesInBulkDialog: false,
    addRouteSchedulesInBulk: {
      type: "Default",
      driver_bus: "",
      dateFromPickerMenu: false,
      dateFrom: "",
      dateToPickerMenu: false,
      dateTo: "",
      term: "",
    },

    weekDayList: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
    ],

    processing: false,
    deleting: false,
    selected: [],
    files: [],
    url: "",
    currentRegID: "",
    regID: "",

    routeScheduleAbsents: {},
    routeScheduleAbsentsDialog: false,

    rules: {
      required: (value) => !!value || "Required.",
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
      busDriverRequired: (value, routeSchedule) => {
        return (
          !routeSchedule.dateFrom ||
          !routeSchedule.dateTo ||
          !routeSchedule.type ||
          !!value ||
          "Required."
        );
      },
      routeScheduleTypeRequired: (value, routeSchedule) => {
        return (
          !routeSchedule.dateFrom ||
          !routeSchedule.dateFrom ||
          !routeSchedule.driver_bus ||
          !!value ||
          "Required."
        );
      },
    },
  }),
  methods: {
    openDeleteRouteSchedule(routeSchedule) {
      this.routeScheduleToDelete = routeSchedule;
      this.routeScheduleDeleteDialog = true;
    },
    editRouteSchedule(routeSchedule) {
      this.routeScheduleToEdit = JSON.parse(JSON.stringify(routeSchedule));
      this.routeScheduleEditDialog = true;
    },
    openAddRouteSchedule() {
      this.routeScheduleToAdd = {
        route_ID: this.rowClicked.id,
        driver_bus: "",
        type: "Default",
        dateFromPickerMenu: false,
        dateFrom: "",
        dateToPickerMenu: false,
        dateTo: "",
        term: this.currentRegID,
        id: 0,
      };

      this.addRouteScheduleDialog = true;
    },
    formatedDate(date) {
      return date ? moment(date).format("L") : "";
    },
    validate() {
      const validations = [
        this.$refs.description.validate(true),
        this.$refs.direction.validate(true),
        this.$refs.routeIdentifier.validate(true),
        this.$refs.groupBy.validate(true),
      ];

      return validations.every(Boolean);
    },
    async saveRoute() {
      if (!this.validate()) return;

      if (
        this.rowClicked.routeSchedules.some(
          (schedule) =>
            schedule.dateFrom &&
            schedule.dateTo &&
            new Date(schedule.dateFrom) > new Date(schedule.dateTo)
        )
      ) {
        return this.$notify({
          text: "From Date is later than the To Date",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const routeSchedules = this.rowClicked.routeSchedules
          .filter((r) => r.driver_bus)
          .map((schedule) => {
            const driver_bus = this.driver_busList.find(
              (d) => d.displayName == schedule.driver_bus
            );

            return {
              id: schedule.id,
              driver_Bus_ID: driver_bus.id,
              type: schedule.type,
              term: schedule.term,
              dateFrom: schedule.dateFrom
                ? moment(schedule.dateFrom).format("L")
                : "",
              dateTo: schedule.dateTo
                ? moment(schedule.dateTo).format("L")
                : "",
            };
          });

        await this.$http.post("api/route/save", {
          route: {
            id: this.rowClicked.id,
            term: this.rowClicked.term,
            timeStart: this.getTimeStart(this.rowClicked.timeStart),
            direction: this.rowClicked.direction,
            buildings: this.rowClicked.buildings.join(","),
            grades: this.rowClicked.grades.join(","),
            description: this.rowClicked.description,
            weekDays: this.sortWeekdays(this.rowClicked.weekDays).join(","),
            color: this.rowClicked.color,
            notes: this.rowClicked.notes,
            routeIdentifier: this.rowClicked.routeIdentifier,
            groupBy: this.rowClicked.groupBy,
            goeNotRequired: this.rowClicked.goeNotRequired,
          },
          routeSchedules,
        });

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.updateRouteDialog = false;
        this.processing = false;

        this.reloadGrid();
        this.closeUpdateRouteDialog();
      } catch (e) {
        console.log(e);
        this.processing = false;
      }
    },
    getTimeStart(value) {
      var date = new Date(value);
      var hour = date.getHours();
      var minutes = date.getMinutes();

      // Convert to 12-hour clock
      var period = hour >= 12 ? "PM" : "AM";
      hour = hour > 12 ? hour - 12 : hour;
      hour = hour === 0 ? 12 : hour;

      // Format minutes
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      return hour + ":" + minutes + " " + period;
    },
    sortWeekdays(days) {
      const weekdayOrder = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      return days.sort(
        (a, b) => weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b)
      );
    },
    isOverlapping(routeSchedules, scheduleToEdit) {
      for (let i = 0; i < routeSchedules.length; i++) {
        // check if scheduleToEdit date range overlaps with any other schedule
        if (
          scheduleToEdit.dateFrom >= routeSchedules[i].dateFrom &&
          scheduleToEdit.dateFrom < routeSchedules[i].dateTo &&
          routeSchedules[i].dateTo !== null
        ) {
          // scheduleToEdit overlaps with this schedule, return true
          return true;
        }
        if (
          scheduleToEdit.dateTo !== null &&
          scheduleToEdit.dateTo >= routeSchedules[i].dateFrom &&
          scheduleToEdit.dateTo < routeSchedules[i].dateTo
        ) {
          // scheduleToEdit overlaps with this schedule, return true
          return true;
        }
        // check if any other schedules has a null dateTo - meaning it runs till end of time
        if (
          scheduleToEdit.dateTo === null &&
          routeSchedules[i].dateTo === null
        ) {
          // overlapping as both schedules run till end of time
          return true;
        }
      }

      // if no overlaps, return false
      return false;
    },
    isDateFromLater(routeSchedule) {
      if (!routeSchedule.dateTo) return;

      if (routeSchedule.dateFrom > routeSchedule.dateTo) {
        return true;
      } else {
        return false;
      }
    },
    async saveRouteSchedule({ routeSchedule }) {
      if (!routeSchedule.driver_bus) {
        return this.$notify({
          group: "notification",
          text: "Missing Driver / Bus.",
          type: "error",
        });
      }

      if (!routeSchedule.dateFrom) {
        return this.$notify({
          group: "notification",
          text: "Missing start date.",
          type: "error",
        });
      }

      if (this.isDateFromLater(routeSchedule)) {
        return this.$notify({
          group: "notification",
          text: "The start date must be before the end date.",
          type: "error",
        });
      }

      if (
        this.isOverlapping(
          this.rowClicked.routeSchedules.filter(
            (r) => r.id != routeSchedule.id
          ),
          routeSchedule
        )
      ) {
        return this.$notify({
          group: "notification",
          text:
            "There is another active schedule for the selected dates, please adjust.",
          type: "error",
        });
      }

      const driver_bus = this.driver_busList.find(
        (d) => d.displayName == routeSchedule.driver_bus
      );

      const originalRouteScheduleID = this.getOriginalRouteScheduleID(
        routeSchedule
      );

      if (originalRouteScheduleID) {
        const originalRouteSchedule = await this.$http.get(
          "api/route/getRouteScheduleByID?id=" + originalRouteScheduleID
        );

        const isDriverChange =
          driver_bus.id != originalRouteSchedule.driver_Bus_ID;

        let isDriverChangeIssue = false;

        if (isDriverChange) {
          const existingData = await this.$http.post(
            "api/route/getAbsentsForDriversChange",
            {
              ExistingDriverBusID: originalRouteSchedule.driver_Bus_ID,
              StartDate: routeSchedule.dateFrom,
              EndDate: routeSchedule.dateTo,
              RouteID: this.rowClicked.id,
            }
          );

          isDriverChangeIssue = existingData.existingDriverAbsents.length;

          if (isDriverChangeIssue) {
            this.routeScheduleAbsents = existingData;

            this.routeScheduleAbsentsDialog = true;
            return;
          }
        }
      }

      try {
        this.processing = true;

        const data = JSON.parse(JSON.stringify(routeSchedule));

        data.driver_Bus_ID = driver_bus.id;

        delete data.driver_bus;

        await this.$http.post("api/route/saveRouteSchedule", data);

        this.routeScheduleEditDialog = false;
        this.addRouteScheduleDialog = false;

        this.processing = false;

        this.loadRouteSchedules();

        this.routeScheduleAbsents = {};

        this.$notify({
          group: "notification",
          text: "Changes Saved",
          type: "success",
        });

        this.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    getOriginalRouteScheduleID(routeSchedule) {
      if (routeSchedule.id == 0) {
        return this.rowClicked.dateFrom
          ? this.rowClicked.routeScheduleID
          : null;
      }

      return routeSchedule.id;
    },
    async deleteRouteSchedule() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/route/deleteRouteSchedule?id=" + this.routeScheduleToDelete.id
        );

        this.routeScheduleDeleteDialog = false;

        this.processing = false;

        this.loadRouteSchedules();

        this.$notify({
          group: "notification",
          text: "Route Schedule Deleted",
          type: "success",
        });

        this.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    getDriverByDriverBusID(driver_Bus_ID) {
      const driver_bus = this.driver_busList.find((d) => d.id == driver_Bus_ID);

      return driver_bus ? driver_bus.name + " - " + driver_bus.busNumber : "";
    },
  },
};
</script>
